import Trace from '@/creditflowresearch/ui/components/trace';
import { PageContentLayout } from '@/creditflowresearch/ui/common/components/ContentLayouts';

import withApplicationPropsV2 from '@/creditflowresearch/application/withApplicationPropsV2';
import TraceAssetClassesContextProvider from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';
import TraceFiltersContextProvider from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import FiltersContextProvider from '@/creditflowresearch/application/FiltersContext';
import TraceTableContextProvider from '@/creditflowresearch/application/Trace/TraceTableContext';

import { getServerSideAssetClasses } from '@/creditflowresearch/application/Trace/serverSide/getServerSideAssetClasses';
import { getServerSideFiltersData } from '@/creditflowresearch/application/Trace/serverSide/getServerSideFiltersData';

import getServerSideTraceBreadcrumbs from '@/creditflowresearch/application/Breadcrumbs/serverSide/getServerSideTraceBreadcrumbs';
import TraceContextProvider from '@/creditflowresearch/application/Trace/TraceContext';
import PageFiltersContextProvider from '@/creditflowresearch/application/PageFilters/PageFiltersContext';

export const getServerSideProps = withApplicationPropsV2(async (context) => {
  const assetClasses = await getServerSideAssetClasses(context);
  const filtersPayload = await getServerSideFiltersData(context, assetClasses);
  const breadcrumbs = getServerSideTraceBreadcrumbs();

  return ({
    props: {
      assetClasses,
      filtersPayload,
      breadcrumbs,
    },
  });
}, { needsLegacyDictionaries: false });

export default (props) => {
  const { assetClasses, filtersPayload } = props;
  const { filter, ...baseParams } = filtersPayload;

  return (
    <PageFiltersContextProvider>
      <TraceFiltersContextProvider>
        <TraceAssetClassesContextProvider initial={ assetClasses }>
          <FiltersContextProvider initial={ { baseParams, updateLocation: true } }>
            <TraceTableContextProvider>
              <TraceContextProvider initial={ filtersPayload }>
                <PageContentLayout>
                  <Trace { ...props } />
                </PageContentLayout>
              </TraceContextProvider>
            </TraceTableContextProvider>
          </FiltersContextProvider>
        </TraceAssetClassesContextProvider>
      </TraceFiltersContextProvider>
    </PageFiltersContextProvider>
  );
};
